import React from "react"
import { TextField } from "material-ui"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import * as accountActions from "../../../actions/AccountActions"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import autobind from "class-autobind"
import { IHierarchyItem } from "../../../models"
import * as api from "../../../api"
interface IProps {
	hierarchyItem: any
	readonly: boolean
}
interface IState {
	name: string
	errorName: string
	costCenter: string
	errorCostCenter: string
	payrollExportName: string
	externalID: string
}

export default class HierarchyDetails extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			name: "",
			errorName: "",
			costCenter: "",
			errorCostCenter: "",
			payrollExportName: "",
			externalID: ""
		}
		autobind(this)
	}

	componentDidMount() {
		if (!this.props.hierarchyItem) return
		this.setHierarchyItemInfoForm(this.props.hierarchyItem)
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.hierarchyItem) return
		if (this.props.hierarchyItem.level && nextProps.hierarchyItem.level) return
		if (this.props.hierarchyItem.Id && nextProps.hierarchyItem.Id && this.props.hierarchyItem.Id === nextProps.hierarchyItem.Id) return
		this.setHierarchyItemInfoForm(nextProps.hierarchyItem)
	}

	setHierarchyItemInfoForm(hierarchyItem) {
		const hierarchyInfo = this.getHierarchyInfo(hierarchyItem)
		this.setState({
			name: hierarchyInfo.name,
			costCenter: hierarchyInfo.costCenter,
			externalID: hierarchyInfo.externalID,
			payrollExportName: hierarchyInfo.payrollExportName,
			errorName: ""
		})
	}

	getHierarchyInfo(hierarchyItem) {
		const payload = hierarchyItem.level && hierarchyItem.level === -1 ? AccountStore.getCurrentAccount() : hierarchyItem
		const name = hierarchyItem.level && hierarchyItem.level === -1 ? payload.Name : payload.Label
		const costCenter = payload.CostCenter ? payload.CostCenter : ""
		const externalID = payload.ExternalId ? payload.ExternalId : ""
		const payrollExportName = payload.PayrollExportName ? payload.PayrollExportName : ""

		return { name, costCenter, externalID, payrollExportName }
	}

	checkValidate() {
		let isValidate = true
		if (!this.state.name.trim()) {
			this.setState({ errorName: strings.Name_cannot_be_empty })
			isValidate = false
		}
		else {
			const parentId = this.props.hierarchyItem.level !== undefined ?
				null :
				(this.props.hierarchyItem as IHierarchyItem).ParentId
			if (HierarchySettingsStore.getGlobalLevelItemFilter() && AccountStore.getCurrentAccount().HierarchyItems.filter(item => item.ParentId === parentId).find(item => item.Id !== HierarchySettingsStore.getGlobalLevelItemFilterId() && item.Label === this.state.name.trim())) {
				this.setState({ errorName: strings.Hierarchy_name_is_duplicated })
				isValidate = false
			}
			else {
				this.setState({ errorName: "" })
			}
		}

		return new Promise(resolve =>
			!isValidate ?
				resolve(false) :
				this.state.costCenter.trim() ?
					api.checkValidateHierarchyCostCode(AccountStore.getCurrentAccount().Id, this.props.hierarchyItem.Id, this.state.costCenter.trim()).then(res =>
						this.setState({ errorCostCenter: res.data === false ? strings.Cost_Center_is_duplicated : "" }, () =>
							resolve(res.data)
						)
					) :
					this.setState({ errorCostCenter: "" }, () => resolve(true))
		)
	}

	async handleUpdate() {
		const validate = await this.checkValidate()
		if (!validate) return

		const originalHierarchyInfo = this.getHierarchyInfo(this.props.hierarchyItem)
		const name = this.state.name.trim()
		const costCenter = this.state.costCenter.trim()
		const payrollExportName = this.state.payrollExportName.trim()
		const externalID = this.state.externalID.trim()
		if (name === originalHierarchyInfo.name &&
			costCenter === originalHierarchyInfo.costCenter &&
			payrollExportName === originalHierarchyInfo.payrollExportName &&
			externalID === originalHierarchyInfo.externalID
		)
			return

		AppStateStore.setProgressSnackbarContent("loading")
		if (this.props.hierarchyItem.level && this.props.hierarchyItem.level === -1) {
			const payload = {
				Name: name,
				CostCenter: costCenter,
				PayrollExportName: payrollExportName,
				ExternalId: externalID
			}
			accountActions.patchAccount(AccountStore.getCurrentAccount().Id, payload,
				() => AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
			)
		}
		else {
			const hierarchyItem = this.props.hierarchyItem
			hierarchyItem.Label = name
			hierarchyItem.CostCenter = costCenter
			hierarchyItem.ExternalId = externalID
			hierarchyItem.PayrollExportName = payrollExportName
			accountActions.updateAccountHierarchyItem(AccountStore.getCurrentAccount().Id, hierarchyItem, false, null,
				() => AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
			)
		}
	}

	render() {
		return (
			<div className="HierarchyDetails">
				<div style={{ background: "#FAFAFA", maxWidth: 700 }}>
					<div className="HierarchyItemInfoForm" style={{ padding: 30, textAlign: "center" }}>
						<TextField
							data-intercom-target={"menu-Hierarchy-Details-Entry-Name"}
							floatingLabelText={strings.Name}
							value={this.state.name}
							onChange={(e) => this.setState({ name: e.target.value.substr(0, 60) }, () => this.checkValidate())}
							onBlur={() => this.handleUpdate()}
							disabled={this.props.readonly || !HierarchySettingsStore.getGlobalLevelItemFilterId()}
							errorText={this.state.errorName}
							errorStyle={{ position: "absolute", bottom: -9 }}
							style={{ marginRight: 20, width: 300 }}
						/>
						<TextField
							data-intercom-target={"menu-Hierarchy-Details-Entry-CostCenter"}
							floatingLabelText={strings.CostCenter}
							value={this.state.costCenter}
							onChange={(e) => this.setState({ costCenter: e.target.value.substr(0, 40) }, () => this.checkValidate())}
							onBlur={() => this.handleUpdate()}
							disabled={this.props.readonly}
							errorText={this.state.errorCostCenter}
							errorStyle={{ position: "absolute", bottom: -9 }}
							style={{ width: 300 }}
						/>
						<TextField
							data-intercom-target={"menu-Hierarchy-Details-Entry-PayrollExportName"}
							floatingLabelText={strings.PayrollExportName}
							value={this.state.payrollExportName}
							onChange={(e) => this.setState({ payrollExportName: e.target.value.substr(0, 40) }, () => this.checkValidate())}
							onBlur={() => this.handleUpdate()}
							disabled={this.props.readonly}
							style={{ marginRight: 20, width: 300 }}
						/>
						<TextField
							data-intercom-target={"menu-Hierarchy-Details-Entry-ExternalId"}
							floatingLabelText={strings.External_ID}
							value={this.state.externalID}
							onChange={(e) => this.setState({ externalID: e.target.value.substr(0, 40) }, () => this.checkValidate())}
							onBlur={() => this.handleUpdate()}
							disabled={this.props.readonly}
							style={{ width: 300 }}
						/>
					</div>
				</div>
			</div>
		)
	}
}